import { useEffect, useCallback } from 'react'

import { publisherWorkflowsT } from 'services/workflows/publisher_workflows_i18n'

import { TimingErrorMessage, TimingInputBlock, TimingSelect, TimingTextField } from './styles'

const unitLimits = {
  days: 999,
  hours: 720,
  minutes: 43200
}
const unitTypes = Object.keys(unitLimits)

export const TimingInput = ({
  value,
  units,
  onChange,
  onError = (() => { }),
  notZero = false,
  isAppShellRebrand = false
}) => {
  // i18n-tasks-use t('publisher.workflows.forms.trigger.units.#{unit}')
  const isError = useCallback(() => (notZero && value === 0), [notZero, value])
  const timingUnitsOptions = unitTypes.map((unit) => ({
    id: unit,
    name: publisherWorkflowsT(`publisher.workflows.forms.trigger.units.${unit}`, isAppShellRebrand)
  }))
  const { name } = timingUnitsOptions.find(({ id }) => id === units)

  useEffect(() => {
    onError(isError())
  }, [isError, onError])

  function onChangeWithLimits(newValue, newUnits) {
    onChange(
      Math.min(unitLimits[newUnits], newValue),
      newUnits
    )
  }

  function onValueChange(event) {
    if (event.target.value.match(/^\d*$/) === null) {
      return
    }
    onChangeWithLimits(event.target.value, units)
  }

  function onUnitsChange(newUnits) {
    onChangeWithLimits(value, newUnits)
  }

  return (
    <>
      <TimingInputBlock>
        <TimingTextField
          value={value}
          onChange={onValueChange}
          maxLength={5}
          errors={isError() ? [''] : []}
          aria-label={name}
        />
        <TimingSelect
          aria-label={publisherWorkflowsT('publisher.workflows.triggers.custom_unit_label', isAppShellRebrand)}
          value={units}
          onChange={onUnitsChange}
          options={timingUnitsOptions}
        />
      </TimingInputBlock>
      {isError() && (
        <TimingErrorMessage message={publisherWorkflowsT('publisher.workflows.forms.not_zero', isAppShellRebrand)} />
      )}
    </>
  )
}
